module.exports = __webpack_public_path__ + "static/media/roof-2.e4e69a73.jpeg";